import axios from 'axios';

import { ConnectionTreeModel, EdgeModel, NodeModel } from './connectionTree.model';

const getNodes = async () => {
  const response = await axios.get<NodeModel[]>('connectionTree/nodes');

  return response.data;
};

const getEdges = async () => {
  const response = await axios.get<EdgeModel[]>('connectionTree/edges');

  return response.data;
};

const getConnectionTree = async () => {
  const response = await axios.get<ConnectionTreeModel>('connectionTree');

  return response.data;
};

const ConnectionTree = {
  getNodes,
  getEdges,
  getConnectionTree,
};

export default ConnectionTree;
